import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorDistinctionBanner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorDistinctionBanner" */ '../src/EditorDistinctionBanner'
			)
		).EditorDistinctionBanner,
});
